<template>
  <v-container fluid grid-list-md>
    <service-requirements-list></service-requirements-list>
  </v-container>
</template>
<script>
import ServiceRequirementsList from '../components/ServiceRequirements/List.vue';

export default {
  components: {
    ServiceRequirementsList,
  },
};
</script>
